module.exports = __webpack_public_path__ + "img/whatsapp.60e23a42.png";